























































































import { Component, Ref, Mixins } from "vue-property-decorator";
import MediumAudience from "@/models/MediumAudience";
import MediumAudienceMixin, {
  GET_ADMIN_MEDIUM_AUDIENCE,
} from "@/mixins/http/MediumAudienceMixin";
import VDataTable from "@monade/vue-components/src/components/VDataTable.vue";
import Paginator from "@monade/vue-components/src/components/VPaginator.vue";
import Beautify from "@/filters/Beautify";
import { RegisterHttp } from "../../utils/Decorators";
import RequestData from "@/store/types/RequestData";
import MediumAudienceModal from "@/components/Admin/MediumAudienceModal.vue";
import ConfirmDeletion from "@/components/Admin/ConfirmDeletion.vue";
import MediumAudienceBatchModal from "@/components/Admin/MediumAudienceBatchModal.vue";

interface ColumnData {
  name: string;
  label: string;
}

@Component({
  components: {
    VDataTable,
    Paginator,
    MediumAudienceModal,
    ConfirmDeletion,
    MediumAudienceBatchModal,
  },
  filters: {
    Beautify,
  },
})
export default class MediaAudience extends Mixins(MediumAudienceMixin) {
  loading = false;
  items: MediumAudience[] = [];
  page = 1;
  term = "";

  @Ref() readonly mediumAudienceModal!: MediumAudienceModal;
  @Ref() readonly confirmDeletion!: ConfirmDeletion;
  @Ref() readonly mediumAudienceBatchModal!: MediumAudienceBatchModal;

  @RegisterHttp(GET_ADMIN_MEDIUM_AUDIENCE)
  request?: RequestData;

  get meta() {
    return this.request?.meta;
  }

  get columns() {
    const columns: ColumnData[] = [];

    this.pushColumnInAllScreens(columns, { name: "region", label: "Regione" });
    this.pushColumnInAllScreens(columns, {
      name: "district",
      label: "Provincia",
    });
    this.pushColumnInAllScreens(columns, { name: "town", label: "Comune" });
    this.pushColumnInAllScreens(columns, { name: "postalCode", label: "CAP" });
    this.pushColumnInAllScreens(columns, { name: "value", label: "Audience" });
    this.pushColumnInAllScreens(columns, { name: "action", label: "" });

    return columns;
  }

  onEditMediumAudience(value: MediumAudience) {
    this.mediumAudienceModal.open(value, "");
  }

  async onMediumChanged(value: MediumAudience) {
    try {
      await this.putAdminMediumAudience(this.$route.params.id, value);
      this.mediumAudienceModal.close();
      await this.loadData();
    } catch (e) {
      await this.loadData();
    }
  }

  onDeleteMediumAudience(value: MediumAudience) {
    this.confirmDeletion.open(value.id);
  }

  onSearch() {
    this.page = 1;
    this.loadData();
  }

  onTermChanged() {
    if (this.term.match(/[a-z]?/)) {
      this.term = this.term.toUpperCase();
    }
  }

  async onPageChange(page: number) {
    this.page = page;
    await this.loadData();
  }

  async onConfirmDeletion(id: string) {
    try {
      await this.deleteAdminMediumAudience(this.$route.params.id, id);
    } finally {
      await this.loadData();
    }
  }

  onBatch() {
    this.mediumAudienceBatchModal.show();
  }

  async onBatchSave(value: {
    audience: number;
    postalCode?: string;
    region?: string;
    district?: string;
    town?: string;
  }) {
    try {
      await this.postMassiveMediumAudience(this.$route.params.id, value);
    } finally {
      this.mediumAudienceBatchModal.close();
      this.loadData();
    }
  }

  async mounted() {
    await this.loadData();
  }

  async loadData() {
    const id = this.$route.params.id;
    this.loading = true;
    this.items = await this.getAdminMediaAudience(id, this.page, this.term);
    this.loading = false;
  }

  private pushColumnInAllScreens(columns: ColumnData[], column: ColumnData) {
    columns.push(column);
  }
}
